/**
 * Справочник категорий с сервера (U7): подписи объектов ведёт админ в кабинете,
 * а не словарь в коде. Загружается один раз при старте вьюера и мягко: пока не
 * пришёл (или если недоступен), подписи берутся из встроенного словаря i18n —
 * карта не должна ждать справочник, чтобы показаться.
 */
let dict: Record<string, Record<string, string>> = {}
/** key → имя глифа, выбранное админом (categories.icon). */
let icons: Record<string, string> = {}

/**
 * Значок категории, назначенный админом (01.08). null — значок по ключу
 * категории, как было: справочник ничего не ломает, а только уточняет.
 */
export function categoryIcon(key: string): string | null {
  return icons[key] ?? null
}

/** Переводы категории из справочника; null — в справочнике её нет. */
export function categoryNames(key: string): Record<string, string> | null {
  return dict[key] ?? null
}

/** Загрузить справочник в фоне. Ошибка — не беда: остаётся словарь i18n. */
export function loadCategories(): void {
  fetch('/api/categories')
    .then((res) => (res.ok ? res.json() : null))
    .then(
      (
        data: {
          categories?: { key: string; names: Record<string, string>; icon?: string }[]
        } | null,
      ) => {
        if (!data?.categories) return
        const next: Record<string, Record<string, string>> = {}
        const nextIcons: Record<string, string> = {}
        for (const row of data.categories) {
          next[row.key] = row.names
          if (row.icon) nextIcons[row.key] = row.icon
        }
        dict = next
        icons = nextIcons
      },
    )
    .catch(() => {
      // офлайн или сервер недоступен — подписи из встроенного словаря
    })
}
